var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.3466,
    height: 9.87864,
    transform: "matrix(1 0 5.14415e-08 -1 8.34375 9.87891)",
    fill: "#FF3700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7129 14.082L3.20517 7.90379L18.2207 7.90379L10.7129 14.082Z",
    fill: "#FF3700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00516 13.8291L10.7114 16.0561L13.4176 13.8291H20.5913V18.1757H13.1128L10.7126 20.1507L8.31243 18.1757H0.833984V13.8291H8.00516Z",
    fill: "#FF3700"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download.c6dc8463.svg";
export { ForwardRef as ReactComponent };